import { TactikSiteTopBar } from "../app/TactikSiteTopBar";
import CustomerOrdersPage from "../../customer_account/OrdersPage";

export default function StandaloneOrdersPage(): JSX.Element {
  return (
    <CustomerOrdersPage scope="standalone" topBar={<TactikSiteTopBar />} />
  );
}
